import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=285b20b8&scoped=true"
import script from "./apply.vue?vue&type=script&lang=js"
export * from "./apply.vue?vue&type=script&lang=js"
import style0 from "./apply.vue?vue&type=style&index=0&id=285b20b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285b20b8",
  null
  
)

export default component.exports